
<app-title-bar
  title="Onboard company"
  description="Create a new company admin account and company profile."
  [showButton]="false">
</app-title-bar>

<form class="admin-company-onboard-form" [formGroup]="form" (ngSubmit)="submit()">
  <section class="admin-company-onboard-section">
    <h2 class="admin-company-onboard-section__title">Company admin</h2>
    <div class="admin-company-onboard-grid">
      <div class="form-group">
        <label for="name">Admin name</label>
        <input id="name" class="form-control" type="text" formControlName="name" />
        <small class="field-error" *ngIf="showError('name')">{{ controlError('name') }}</small>
      </div>
      <div class="form-group">
        <label for="email">Admin email</label>
        <input id="email" class="form-control" type="email" formControlName="email" />
        <small class="field-error" *ngIf="showError('email')">{{ controlError('email') }}</small>
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input id="password" class="form-control" type="password" formControlName="password" />
        <small class="field-error" *ngIf="showError('password')">{{ controlError('password') }}</small>
      </div>
      <div class="form-group">
        <label for="contact_number">Admin phone</label>
        <input id="contact_number" class="form-control" type="tel" formControlName="contact_number" />
        <small class="field-error" *ngIf="showError('contact_number')">{{ controlError('contact_number') }}</small>
      </div>
    </div>
  </section>

  <section class="admin-company-onboard-section">
    <h2 class="admin-company-onboard-section__title">Company details</h2>
    <div class="admin-company-onboard-grid">
      <div class="form-group">
        <label for="shop_name">Company name</label>
        <input id="shop_name" class="form-control" type="text" formControlName="shop_name" />
        <small class="field-error" *ngIf="showError('shop_name')">{{ controlError('shop_name') }}</small>
      </div>
      <div class="form-group">
        <label for="shop_email">Company email</label>
        <input id="shop_email" class="form-control" type="email" formControlName="shop_email" />
        <small class="field-error" *ngIf="showError('shop_email')">{{ controlError('shop_email') }}</small>
      </div>
      <div class="form-group">
        <label for="shop_contact">Company phone</label>
        <input id="shop_contact" class="form-control" type="tel" formControlName="shop_contact" />
        <small class="field-error" *ngIf="showError('shop_contact')">{{ controlError('shop_contact') }}</small>
      </div>
      <div class="form-group">
        <label for="logo">Company logo</label>
        <input id="logo" class="form-control" type="file" accept="image/*" (change)="onLogoSelected($event)" />
        <small class="field-error" *ngIf="logoError">{{ logoError }}</small>
        <div class="admin-company-onboard-logo-preview" *ngIf="logoPreviewUrl">
          <img [src]="logoPreviewUrl" alt="Logo preview" />
        </div>
      </div>
    </div>
  </section>

  <div class="admin-company-onboard-actions">
    <a routerLink="/admin/companies" class="btn btn-outlined btn-medium">Cancel</a>
    <button type="submit" class="btn btn-primary btn-medium" [disabled]="submitting">
      {{ submitting ? 'Creating…' : 'Create company' }}
    </button>
  </div>
</form>
